// extracted by mini-css-extract-plugin
module.exports = {"label":"_2XNiPrUSopbsaHUpWRyRZ","activeLabel":"qiwkX6vGLqg_Ao7n09Q2F _2XNiPrUSopbsaHUpWRyRZ","labelName":"gQORZ8DA2-7iwfvV17GEw","labelOptions":"_2ruQdDDswkacxT947KuF3o"};